/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { logoVoxel, mascot_img_main } from '../../imagepath';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { notification } from 'antd';
import apiService from '../../../axios/apiService';
import Loader from '../../../common/loader.jsx';
import PinInput from 'react-pin-input';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extract the invitationId from the query parameters
  const invitationId = queryParams.get('invitationId');
  const [isDisabled, setIsDisabled] = useState(true);
  const [formToggle, setFormToggle] = useState(true);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const inviteUserDetails = async () => {
      try {
        setIsLoading(true);
        let user = await apiService.getInvitedUser(invitationId);
        setUserData(user?.data?.data);
        setValue('nameTitle', user?.data?.data?.nameTitle);
        setValue('firstName', user?.data?.data?.firstName);
        setValue('lastName', user?.data?.data?.lastName);
        setValue('email', user?.data?.data?.email);
        setValue('mobile', user?.data?.data?.mobile);
      } catch (error) {
        console.log('error: ', error);
      } finally {
        setIsLoading(false);
      }
    };
    inviteUserDetails();
  }, []);
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      let payload = {
        email: data.email,
        mobile: data.mobile,
        firstName: data.firstName,
        lastName: data.lastName,
        nameTitle: data.nameTitle,
        password: data.password,
        invitationId: invitationId,
      };
      let user = await apiService.signUPUser(payload);
      setIsLoading(false);
      if (user) {
        api.success({
          message: 'Success',
          description: 'Rigistration Done Successfully',
          showProgress: false,
        });
        setFormToggle(false);

        reset();
      }
    } catch (error) {
      api.error({
        message: error?.response?.data?.error,
        description: error?.response?.data?.message,
        showProgress: false,
        // pauseOnHover,
      });
      console.error('Error registering user:', error.msg);
      setIsLoading(false);
    }
  };
  return (
    <>
      {contextHolder}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <div className="col-lg-6 login-wrap">
              <div className="login-sec-centered">
                <div className="log-img">
                  <img className="img-fluid" src={mascot_img_main} alt="Logo" />
                </div>
              </div>
            </div>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo">
                        <Link to="#">
                          <img src={logoVoxel} alt="#" />
                        </Link>
                      </div>
                      <h2>Clinic Signup</h2>
                      <h4>
                        You have Invitation From <u>{userData?.clinicTitle}</u>
                      </h4>
                      <br></br>

                      {/* Form */}
                      {formToggle ? (
                        <form action="./" onSubmit={handleSubmit(onSubmit)}>
                          <div className="form-group">
                            <label>
                              Title <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              disabled={isDisabled}
                              {...register('nameTitle', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.nameTitle && <p>Please enter Title</p>}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>
                              First Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              disabled={isDisabled}
                              {...register('firstName', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.firstName && (
                                <p>Please enter First name</p>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>
                              Last Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              disabled={isDisabled}
                              {...register('lastName', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.lastName && (
                                <p>Please enter First name</p>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>
                              Mobile <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              {...register('mobile', {
                                required: 'Please enter Your Mobile Number!',
                                pattern: {
                                  value: /^(\+?1)?[-. ]?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                  message: "Please enter valid US mobile number (e.g. +1-234-567-8900)"
                                },
                              })}
                              disabled={isDisabled}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.mobile?.message}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              {...register('email', {
                                required: 'Please enter Your Email!',
                                pattern: {
                                  value:
                                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: 'Please enter A Valid Email!',
                                },
                              })}
                              disabled={isDisabled}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.email?.message}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>
                              Password <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control pass-input"
                              type="password"
                              {...register('password', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.password && <p>Please enter Password</p>}
                            </small>
                            <span className="profile-views feather-eye-off toggle-password" />
                          </div>
                          <div className="form-group login-btn">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Sign up
                            </button>
                          </div>
                        </form>
                      ) : (
                        <>
                          <div className="form-group">
                            <label>
                              Enter OTP <span className="login-danger">*</span>
                            </label>
                            <PinInput
                              length={6}
                              initialValue=""
                              type="numeric"
                              inputMode="number"
                              style={{ padding: '10px' }}
                              inputStyle={{ borderColor: 'red' }}
                              inputFocusStyle={{ borderColor: 'blue' }}
                              onComplete={async (value, index) => {
                                console.log('index: ', index);
                                console.log('value: ', value.length);
                                if (value.length) {
                                  try {
                                    setIsLoading(true);

                                    let payload = {
                                      username: userData.email,
                                      code: value,
                                    };
                                    let res =
                                      await apiService.confirmSignupClinic(
                                        payload
                                      );
                                    if (res) {
                                      setIsLoading(false);
                                      api.success({
                                        message: 'Success',
                                        description: res?.data.message,
                                        showProgress: false,
                                      });
                                      setTimeout(() => {
                                        navigate('/');
                                      }, 500);
                                    }
                                  } catch (error) {
                                    console.log('error: ', error);
                                  }
                                }
                              }}
                              autoSelect={true}
                              regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                            />
                          </div>
                        </>
                      )}
                      {/* /Form */}
                      <div className="next-sign"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default Register;
